<p class="title-catalog-card">
  {{ 'app.catalog.search-product.first-word' | translate }}
  <span class="title-catalog-card__second-part">
    {{ 'app.catalog.search-product.second-word' | translate }}
  </span>
</p>

<app-breadcrumb
  *ngIf="showBreadcrumb"
  [breadcrumbs]="breadcrumbs$ | async"
  [rootTitle]="'app.catalog.title' | translate"
  (navigateToMainBreadcrumb)="navigateToMainCategory()"
  (navigateToBreadcrumb)="navigateToCategoryByIndex($event)"
  data-test="catalog-breadcrumb"
>
</app-breadcrumb>
<app-catalog-categories
  *ngIf="showMainCategory$ | async; else subCategories"
  (categorySelected)="navigateToCategory($event)"
  data-test="catalog-main-categories"
></app-catalog-categories>

<ng-template #subCategories>
  <app-catalog-subcategories
    (categorySelected)="navigateToCategory($event.category, $event.replaceLastBreadcrumb)"
    data-test="catalog-subcategories"
  ></app-catalog-subcategories>
</ng-template>
